import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';


class TextHighlight extends Component {
  componentDidMount() {
    this.refreshHighlightedText();
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchKeywords !== prevProps.searchKeywords) {
      this.refreshHighlightedText();
    }
  }

  refreshHighlightedText = () => {
    const node = this.props.getParentNode();
    window.$(node.current).removeHighlight();
    this.highlightNode(node);
  }

  highlightNode = _.debounce((node) => {
    const searchString = this.props.searchKeywords.toLowerCase();
    const words = searchString.split(' ').filter(p => p !== '').reverse();

    words.forEach((word) => {
      window.$(node.current).highlight(word);
    });
  }, 400);

  render() {
    return (
      <Fragment>{ this.props.children }</Fragment>
    );
  }
}

TextHighlight.propTypes = {
  children: PropTypes.node.isRequired,
  searchKeywords: PropTypes.string.isRequired,
  getParentNode: PropTypes.func.isRequired,
}

export default TextHighlight;



// WEBPACK FOOTER //
// ./src/components/case/docket/TextHighlight.jsx